import classNames from 'classnames';
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {TranslateUtils} from 'src/js/common/utils';

import styles from './ExportButton.less';
import {IconButton} from './IconButton';

const I18N = defineMessages({
  EXPORT_BUTTON: {
    id: 'files.export.button',
    defaultMessage: 'Export data',
    description: 'text for list export button',
  },
});

interface OwnProps {
  isDisabled?: boolean;
  titleText?: string;
  onExport: () => void;
}

type Props = OwnProps;

const ExportButtonComponent: React.FC<Props> = (props) => {
  const {
    isDisabled = false,
    onExport,
    titleText = 'common.export.button',
  } = props;
  const intl = useIntl();
  return (
    <IconButton
      className={classNames({
        [styles.dlExportButton]: true,
      })}
      disabled={isDisabled}
      iconClass={'fas fa-share-square'}
      clickCallback={onExport}
      titleText={TranslateUtils.translate(
        {...I18N.EXPORT_BUTTON, id: titleText},
        intl
      )}
    />
  );
};

ExportButtonComponent.displayName = 'ExportButton';

export const ExportButton = ExportButtonComponent;
